import axios from "axios"

import { addEventListener } from "@oddcamp/js-utils/src/event"
import { toggleClass } from "@oddcamp/js-utils/src/attribute"
import { createFocusTrap } from "focus-trap"

import init from "../../shared/utils/init"

// counties, communes, areas

init(() => {
  const countyEl = document.querySelector(`.js--mission-search-page-county`)
  const locationEl = document.querySelector(`.js--mission-search-page-location`)
  if (!countyEl || !locationEl) return

  const csrfToken = document.querySelector(`meta[name=csrf-token]`).content

  axios.defaults.headers.common[`X-CSRF-Token`] = csrfToken

  const fetchLocations = (countyId, preselectedValues = []) => {
    if (!countyId || !countyEl.value) {
      locationEl.querySelector(`button`).disabled = true
      const checkboxItemEls = locationEl.querySelectorAll(
        `.--checkboxes label.form-checkbox input`
      )
      checkboxItemEls.forEach((el) => {
        if (el.checked) {
          el.checked = false
          el.dispatchEvent(new Event(`change`))
        }
      })
      return
    }

    axios({
      method: `get`,
      url: `/api/v1/locations.json?county_id=${encodeURIComponent(countyId)}`,
    }).then(function (response) {
      const responseIds = response.data.map((d) => d.id)
      const checkboxItemEls = locationEl.querySelectorAll(
        `.--checkboxes label.form-checkbox`
      )

      checkboxItemEls.forEach((el) => {
        el.style.display = `none`

        const locationId = el.getAttribute(`for`).replace(`q_location_ids_`, ``)

        if (responseIds.includes(locationId)) {
          el.style.display = `block`
        }
      })

      preselectedValues.forEach((v) => {
        const checkboxEl = locationEl.querySelector(`#q_location_ids_${v}`)

        if (checkboxEl) {
          checkboxEl.checked = true
          checkboxEl.dispatchEvent(new Event(`change`))
        }
      })

      locationEl.querySelector(`button`).disabled = false
    })
  }

  countyEl.addEventListener(`change`, (e) => fetchLocations(e.detail.value))

  if (countyEl.value) {
    const urlParams = new URLSearchParams(window.location.search)
    const preselectedLocations = urlParams
      .getAll(`q[location_ids][]`)
      .filter((l) => !!l)

    fetchLocations(countyEl.value, preselectedLocations)
  }

  locationEl.querySelector(`button`).disabled = true
})

// trigger Follow component's modal

init(() => {
  const triggerEl = document.querySelector(
    `.js--mission-search-page-trigger-follow-modal`
  )
  const followEl = document.querySelector(`.js--mission-search-page-follow`)
  if (!triggerEl || !followEl) return

  triggerEl.addEventListener(`click`, () => {
    followEl.dispatchEvent(new CustomEvent(`follow:displayModal`))
  })
})

// bookmarks (heart-icon)

init(() => {
  const buttons = document.querySelectorAll(`.js--mission-search-page-bookmark`)

  if (!buttons) return

  const disableButtons = (btns) => btns.forEach((b) => (b.disabled = true))
  const enableButtons = () => buttons.forEach((b) => (b.disabled = false))

  const displayOnlyButtons = (buttonEl, method) => {
    buttonEl.parentNode
      .querySelectorAll(`.js--mission-search-page-bookmark`)
      .forEach((b) => {
        if (b.dataset.method === method) {
          b.classList.remove(`is-hidden`)
        } else {
          b.classList.add(`is-hidden`)
        }
      })
  }

  addEventListener(buttons, `ajax:before`, (e, buttonEl) => {
    disableButtons(
      buttonEl.parentNode.querySelectorAll(`.js--mission-search-page-bookmark`)
    )
    displayOnlyButtons(
      buttonEl,
      buttonEl.dataset.method === `post` ? `delete` : `post`
    )
  })

  addEventListener(buttons, `ajax:complete`, enableButtons)
  addEventListener(buttons, `ajax:error`, (e, buttonEl) =>
    toggleClass(buttonEl, `is-hidden`)
  )
})
